module.exports = __webpack_public_path__ + "img/balloon.1df95f4b.svg";